// extracted by mini-css-extract-plugin
module.exports = {"errorsBox":"shared_errorsBox__sZcLb","errorBorder":"shared_errorBorder__71yXg","errorLabel":"shared_errorLabel__7cOS2"};